import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTranslation } from '../../hooks/useTranslation';

interface Tool {
  path: string;
  titleKey: string;
  descriptionKey: string;
}

interface RelatedToolsProps {
  currentTool: string;
  className?: string;
}

const RelatedTools: React.FC<RelatedToolsProps> = ({ currentTool, className = '' }) => {
  const { language } = useLanguage();
  const { t } = useTranslation();

  const tools: Record<string, Tool> = {
    pdfToUbl: {
      path: '/pdf-to-xrechnung',
      titleKey: 'header.features.pdfToXrechnung',
      descriptionKey: 'header.features.pdfToXrechnung.description'
    },
    pdfToCii: {
      path: '/pdf-to-cii',
      titleKey: 'header.features.pdfToCii',
      descriptionKey: 'header.features.pdfToCii.description'
    },
    pdfToZugferd: {
      path: '/pdf-to-zugferd',
      titleKey: 'header.features.pdfToZugferd',
      descriptionKey: 'header.features.pdfToZugferd.description'
    },
    xrechnungToPdf: {
      path: '/xrechnung-to-pdf',
      titleKey: 'header.features.xrechnungToPdf',
      descriptionKey: 'header.features.xrechnungToPdf.description'
    },
    xrechnungViewer: {
      path: '/xrechnung-viewer',
      titleKey: 'header.features.xrechnungViewer',
      descriptionKey: 'header.features.xrechnungViewer.description'
    }
  };

  // Filter out current tool and get related tools
  const relatedTools = Object.entries(tools)
    .filter(([key]) => key !== currentTool)
    .slice(0, 3); // Show max 3 related tools

  if (relatedTools.length === 0) return null;

  return (
    <div className={`mt-12 ${className}`}>
      <h3 className="text-2xl font-semibold text-text-primary mb-6">
        {t('relatedTools.title')}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {relatedTools.map(([key, tool]) => (
          <Link
            key={key}
            to={`/${language}${tool.path}`}
            className="block p-6 bg-bg-primary rounded-lg border border-border-primary hover:border-brand-primary transition-colors group"
          >
            <h4 className="font-semibold text-text-primary mb-2 group-hover:text-brand-primary transition-colors">
              {t(tool.titleKey)}
            </h4>
            <p className="text-sm text-text-secondary">
              {t(tool.descriptionKey)}
            </p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RelatedTools;